<template>
    <div class="notification" :class="notificationClass" v-show="isVisible">
        <button class="delete" @click="isVisible = false"></button>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['type'],

    data() {
        return {
            isVisible: true,
        }
    },

    computed: {
        notificationClass() {
            switch (this.type) {
                case 'error':
                    return 'is-danger'
                    break
                case 'warning':
                    return 'is-warning'
                    break
                default:
                    return 'is-success'
                    break
            }
        },
    },
}
</script>
